import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_eh970f9ptb: FaireBrandEntity = {
  token: "b_eh970f9ptb",
  type: "brand",
  name: "Loli",
  avatarUrl:
    "https://cdn.faire.com/fastly/61fab9c380a1a36f1cc78cdb9ec472529e3635137d6ba6dfce2f1492634c4ac7.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/cd89570c321b0dded7ce0b2a402f40e52f3e11e4047979a2acfc38139bdc869f.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/61fab9c380a1a36f1cc78cdb9ec472529e3635137d6ba6dfce2f1492634c4ac7.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/cd89570c321b0dded7ce0b2a402f40e52f3e11e4047979a2acfc38139bdc869f.jpeg",
  location: "Fort Lee, NJ, USA",
  minimumOrderDollars: 69,
  rating: 5,
  reviewCount: 132,
  isInsider: true,
  description:
    '\nAt Loli, we believe even the smallest sparkle can lift a day. ✨\nWe spread peace, kindness, and good vibes, connecting positive people through meaningful, affordable jewelry.\nWe work from the heart and love to grow together with our partners — because when you shine, we shine too. 💖\n\nLoli is a woman owned business and was started in 2017 by founder Dilek Ilboga, who is the owner of coffee shops with retail and wholesale showroom in Cliffside Park, New Jersey and Brooklyn, New York.  Loli Home is importing from Turkey, working with many women to find the best way to represent its curated selection of jewelry, home decor, and souvenirs. Our collections showcase stunning gemstone and evil eye designs, embodying rich cultural heritage and exceptional craftsmanship. Discover unique pieces that capture both beauty and meaning, all at very accessible prices."',
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:38.540Z",
    importedBy: "entity-db-cli",
  },
};
